import React from 'react';

/**
 * API Debugger Component
 * Helps monitor API calls and prevent infinite loops
 * Only shows in development mode
 */
const ApiDebugger = ({ apiCalls = 0, lastCall = null, error = null }) => {
  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-80 text-white p-4 rounded-lg text-xs font-mono z-50 max-w-sm">
      <div className="font-bold mb-2">🔍 API Debugger</div>
      <div className="space-y-1">
        <div>📡 API Calls: {apiCalls}</div>
        {lastCall && (
          <div>⏰ Last Call: {new Date(lastCall).toLocaleTimeString()}</div>
        )}
        {error && (
          <div className="text-red-400">❌ Error: {error.message}</div>
        )}
        <div className="text-gray-400 mt-2">
          Tip: High call count may indicate infinite loops
        </div>
      </div>
    </div>
  );
};

export default ApiDebugger; 